import { render, staticRenderFns } from "./FlatFileUploadPop.vue?vue&type=template&id=47b9b406"
import script from "./FlatFileUploadPop.vue?vue&type=script&lang=js"
export * from "./FlatFileUploadPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b9b406')) {
      api.createRecord('47b9b406', component.options)
    } else {
      api.reload('47b9b406', component.options)
    }
    module.hot.accept("./FlatFileUploadPop.vue?vue&type=template&id=47b9b406", function () {
      api.rerender('47b9b406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/FlatFileUploadPop.vue"
export default component.exports